import AuthLayout from "../../components/authLayout"
import ForgetPassCard from "../../components/forgetPassCard"

const ForgetPassswordPage = () => {
    return (
        <AuthLayout backgroundImageUrl="/assets/images/backgroundLogin.png">
            <ForgetPassCard />
        </AuthLayout>
    )
}

export default ForgetPassswordPage